<div class="container-fluid ac-poppins mt-4">
    <div class="row margin-bottom">
        <div class=" d-sm-flex">
            <div class="me-auto" style="align-items: center;display: -webkit-inline-box;">
            </div>
            <app-bans-dropdown [banCAs]="banCAs" [ban]="ban" (selectedBAN)="selectBan($event)"></app-bans-dropdown>

        </div>
    </div>
    <div class="row">
        <div class="col-xl-12">
            <div class="card">
                <div class="card-body">
                    <iframe #myDiv id="my_iframe" [src]="url" width="100%" height="100%" target="_parent" frameborder="0"  cellspacing="0" class="ac-speedpayiframe"
                    style="border-style: none;background-color: #ffffff!important;height:65rem" allowfullscreen >
                    </iframe>
                </div>
            </div>
        </div>
    </div>
</div>